module.exports = __webpack_public_path__ + "static/media/therapies-to-consider-green.20ee7272.svg";